module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"content":"Démarche du projet labos 1point5"},"en":{"content":"Labos 1point5 approach"}}')
  delete Component.options._Ctor
}
